/* import __COLOCATED_TEMPLATE__ from './config-editor-link.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

export default class ConfigEditorLinkComponent extends Component
{
	@action updateType(event)
	{
		const newType = event.target.value;
		// Reset type-specific fields when changing type
		const updated = { label: this.args.link.label, type: newType };
		if (newType === 'classGroupResults') {
			updated.classGroupId = '';
			updated.queryParams = { type: '' };
		} else if (newType === 'enduroResults') {
			updated.classGroupId = '';
		} else if (newType === 'pursuitResults') {
			updated.classGroupId = '';
		} else if (newType === 'teamResults') {
			updated.classGroupId = '';
		} else if (newType === 'external') {
			updated.url = '';
		} else if (newType === 'bracket') {
			updated.bracketName = '';
		}
		this.args.onUpdate(updated);
	}

	@action updateField(field, event)
	{
		this.args.onUpdate({ ...this.args.link, [field]: event.target.value });
	}

	@action updateQueryParamType(event)
	{
		this.args.onUpdate({
			...this.args.link,
			queryParams: { ...this.args.link.queryParams, type: event.target.value }
		});
	}
}
